export default __webpack_public_path__ + "static/media/Typescript.894940e2.svg";